import { render, staticRenderFns } from "./labelAttr.vue?vue&type=template&id=ab8bbe5a&scoped=true"
import script from "./labelAttr.vue?vue&type=script&lang=js"
export * from "./labelAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8bbe5a",
  null
  
)

export default component.exports